import { render, staticRenderFns } from "./WorkGroupEdit.vue?vue&type=template&id=44cd7884&scoped=true"
import script from "./WorkGroupEdit.vue?vue&type=script&lang=js"
export * from "./WorkGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkGroupEdit.vue?vue&type=style&index=0&id=44cd7884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd7884",
  null
  
)

export default component.exports